import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";

import {
  AUDITOR_ROLE,
  base_url,
  LOAN_CURRENCY_TYPE_BHD,
  LOAN_CURRENCY_TYPE_USD,
  RATING_A,
  RATING_B,
  RATING_C,
  RATING_D,
} from "../utilities";
import axios from ".././axios-interceptor";
import { toast } from "react-toastify";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { ThreeDots } from "react-loader-spinner";
import Cookies from 'js-cookie';

const AdminNewLoanRequest = (props) => {
  const [tenure, setTenure] = useState(null);
  const [bennefin, setBennefin] = useState("");
  const [investor, setInvestor] = useState("");
  const [ifrequency, setIFrequency] = useState("");
  const [pfrequency, setPFrequency] = useState("");
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState("");
  const [processingfee, setprocessingFeeType] = useState("");
  const [assignee, setAssignee] = useState("");
  const [adminnotes, setAdminNotes] = useState("");
  const [rating, setRating] = useState(null);
  const [show, setShow] = useState(false);
  const [aboutDocument, setAboutDocument] = useState(null);
  const [aboutPreviewHtml, setAboutPreviewHtml] = useState("");
  const [aboutDocumentHash, setAboutDocumentHash] = useState("");
  const [aboutPreviewWarnings, setAboutPreviewWarnings] = useState([]);
  const [aboutPreviewConfirmed, setAboutPreviewConfirmed] = useState(false);
  const [aboutPreviewLoading, setAboutPreviewLoading] = useState(false);
  const [showAboutPreview, setShowAboutPreview] = useState(false);
  const handleShowReject = () => setShow(true);
  const [approvedAmount, setApprovedAmount] = useState("");

  let processing_fee_options = [
    { type: "One Time", id: 0 },
    { type: "Monthly", id: 1 },
  ];
  let processing_fee_options_isfrequency = [{ type: "One Time", id: 2 }];
  let oppurtunity_ratings = ["A", "B", "C", "D"];
  let currency_types = [LOAN_CURRENCY_TYPE_BHD, LOAN_CURRENCY_TYPE_USD];
  let download;

  if (props.data?.documents == undefined) {
    download = [];
  } else {
    download = props.data?.documents;
  }
  let user = Cookies.get("admin_user_name");
  useEffect(() => { }, []);
  let months = [];
  for (let i = 1; i <= 48; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }
  const handleClose = () => {
    props.onHide();
    setUploadFile(null);
    setUploadedUrl(null);
    setRating(null);
    setIFrequency("");
    setApprovedAmount("");
    setAboutDocument(null);
    setAboutPreviewHtml("");
    setAboutDocumentHash("");
    setAboutPreviewWarnings([]);
    setAboutPreviewConfirmed(false);
    setShowAboutPreview(false);
  };

  const {
    handleSubmit,
    formState: { errors },
  } = useForm();
  const radioButtonMethod = (e) => {
    setprocessingFeeType(e.target.value);
  };
  const radioButtonMethodRating = (e) => {
    if (e.target.value == "A") {
      setRating(RATING_A);
    }
    if (e.target.value == "B") {
      setRating(RATING_B);
    }
    if (e.target.value == "C") {
      setRating(RATING_C);
    }
    if (e.target.value == "D") {
      setRating(RATING_D);
    }
  };
  const handleCloseRejectClose = () => {
    setShow(false);
  };
  const handleCloseReject = () => {
    //hit the api from rejection api here
    let loan_id = {
      loan_id: props.data?.loan_id,
      admin_user_id: Cookies.get("admin_user_id"),
      assignee:
        assignee == "" ? Cookies.get("admin_user_name") : assignee,
      admin_notes: adminnotes,
    };
    axios
      .post(base_url + "admin-user/reject_new_loan_request", loan_id)
      .then((res) => {
        if (res.data.status == 200) {
          setShow(false);
          toast.success("Rejected Successfully", {
            toastId: 4,
          });
          setTimeout(() => {
            window.location.reload();
          }, 800);
        }
      });
  };
  const [activeTabBool, setActiveTabBool] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSavechanges = () => {
    const fd1 = new FormData();
    if (
      tenure == null ||
      tenure == "Select" ||
      bennefin == "" ||
      investor == "" ||
      pfrequency == "" ||
      ifrequency == "" ||
      amount == "" ||
      processingfee == "" ||
      rating == "" ||
      aboutDocument == null ||
      aboutDocumentHash == "" ||
      !aboutPreviewConfirmed ||
      approvedAmount == ""
    ) {
      toast.error("Please fill the required fields", {
        toastId: 12,
      });
    } else {
      fd1.append("loan_id", props.data?.loan_id);
      fd1.append("loan_amount", props.data?.loan_amount);
      fd1.append("business_id", props.data?.business_id);
      fd1.append("business_name", props.data?.business_name || "");
      fd1.append("business_type", props.data?.business_type || props.data?.business_name || "Business");
      fd1.append("business_image_url", props.data?.business_image_url || "");
      fd1.append("notes", props.data?.notes || "");
      fd1.append("admin_request_loan_tenure", parseInt(tenure));
      fd1.append("bennefin_roi", bennefin);
      fd1.append("investor_roi", investor);
      fd1.append("principal_frequency", pfrequency);
      fd1.append("interest_frequency", ifrequency);
      fd1.append("rating", rating);
      fd1.append("created_by", Cookies.get("admin_user_name"));
      fd1.append(
        "admin_request_loan_currency",
        currency == "" ? props.data?.loan_currency : currency
      );
      fd1.append("admin_user_id", Cookies.get("admin_user_id"));
      fd1.append("processing_fees_type", processingfee);
      fd1.append("processing_fees", amount);
      fd1.append(
        "assignee",
        assignee == "" ? Cookies.get("admin_user_name") : assignee
      );
      fd1.append("admin_notes", adminnotes);
      fd1.append("about_document", aboutDocument, aboutDocument.name);
      fd1.append("about_document_hash", aboutDocumentHash);
      fd1.append("about_preview_confirmed", "true");
      fd1.append("approved_loan_amount", approvedAmount);
      if (url != null) {
        const fileName = file;
        const lastDotIndex = fileName.lastIndexOf(".");
        const fileExtension = fileName.substring(lastDotIndex + 1);

        fd1.append("file", url, fileExtension);
      }
      if (
        pfrequency == null ||
        pfrequency == "Select" ||
        ifrequency == null ||
        ifrequency == "Select" ||
        rating == null
      ) {
        toast.error("Please fill out mandatory fields", {
          toastId: 3,
        });
      } else {
        setActiveTabBool(true);
        setLoading(true);
        const publishUrl = base_url + "investor-requests/push_to_investor_requests";
        axios
          .post(publishUrl, fd1, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            timeout: 120000,
          })
          .then((res) => {
            if (res.data.status == 200) {
              toast.success("Successfully pushed to investor", {
                toastId: 4,
              });
              props.onHide();
              setTimeout(() => {
                window.location.reload();
              }, 800);
            } else {
              toast.error(res.data?.message || "Unable to push to investor", {
                toastId: 19,
              });
            }
          })
          .catch((error) => {
            toast.error(
              error.response?.data?.message ||
                error.response?.data?.result?.error ||
                "Unable to reach server. Please try again.",
              { toastId: 19 }
            );
          })
          .finally(() => {
            setLoading(false);
            setActiveTabBool(false);
          });
      }
    }
  };
  const [benValue, setBenValue] = useState([]);
  const handleChangeInput = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (name === "tenure") {
      setTenure(value);
    }
    if (name === "bennefin") {
      setBennefin(value);
      setBenValue(value);
    }
    if (name === "investor") {
      if (Number(benValue) < Number(value)) {
        toast.error("Please check the percentage", {
          toastId: 5,
        });
        setInvestor("");
        target.value = "";
      } else {
        setInvestor(value);
      }
    }
    if (name === "i_frequency") {
      setprocessingFeeType("");
      if (value === "Quarterly") {
        setprocessingFeeType("One Time");
      }
      if (name !== "Select") {
        setIFrequency(value);
      }
    }
    if (name === "p_frequency") {
      if (name !== "Select") {
        setPFrequency(value);
      }
    }
    if (name === "amount") {
      setAmount(value);
    }
    if (name === "currency") {
      setCurrency(value);
    }
    if (name === "assignee") {
      setAssignee(value);
    }
    if (name === "admin_notes") {
      setAdminNotes(value);
    }
    if (name === "approved_amount") {
      setApprovedAmount(value);
    }
  };

  const handleDownload = async (url, document_type) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = props.data.business_name + "_" + document_type; // file name
      a.click();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.log(err);
    }
  };
  const [isUpload, setUpload] = useState(false);
  const [file, setUploadFile] = useState(null);
  const [url, setUploadedUrl] = useState(null);

  const handleChangereupload = (event) => {
    if (event.target.files[0].size < 5242880) {
      setUpload(true);
      setUploadFile(event.target.files[0].name);
      setUploadedUrl(event.target.files[0]);
      setUpload(false);
    } else {
      toast.error("File size should be less than 5MB", {
        toastId: 7,
      });
    }
  };
  const handleChangeDownload = (event, file) => {
    const fileUrl = URL.createObjectURL(url);
    window.open(fileUrl, "_blank");
  };

  const resetAboutPreview = () => {
    setAboutPreviewHtml("");
    setAboutDocumentHash("");
    setAboutPreviewWarnings([]);
    setAboutPreviewConfirmed(false);
    setShowAboutPreview(false);
  };

  const handleAboutDocumentChange = (event) => {
    const selectedFile = event.target.files?.[0];
    resetAboutPreview();
    if (!selectedFile) {
      setAboutDocument(null);
      return;
    }

    const extension = selectedFile.name.split(".").pop()?.toLowerCase();
    if (!["docx", "odt"].includes(extension)) {
      toast.error("Please upload a DOCX or ODT document", { toastId: 15 });
      event.target.value = "";
      setAboutDocument(null);
      return;
    }
    if (selectedFile.size > 10 * 1024 * 1024) {
      toast.error("Business information document must be 10MB or smaller", { toastId: 16 });
      event.target.value = "";
      setAboutDocument(null);
      return;
    }
    event.target.value = "";
    setAboutDocument(selectedFile);
  };

  const handlePreviewAboutDocument = async () => {
    if (!aboutDocument) {
      toast.error("Please select a DOCX or ODT document", { toastId: 17 });
      return;
    }

    setAboutPreviewLoading(true);
    setAboutPreviewConfirmed(false);
    const previewData = new FormData();
    previewData.append("about_document", aboutDocument, aboutDocument.name);
    try {
      const response = await axios.post(
        base_url + "investor-requests/preview_about_document",
        previewData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      if (response?.data?.status === 200) {
        setAboutPreviewHtml(response.data.data.html);
        setAboutDocumentHash(response.data.data.hash);
        setAboutPreviewWarnings(response.data.data.warnings || []);
        setShowAboutPreview(true);
      } else {
        throw new Error(response?.data?.message || "Preview failed.");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || error.message || "Unable to preview the document. Please try again.",
        { toastId: 18 }
      );
    } finally {
      setAboutPreviewLoading(false);
    }
  };
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.onHide}
        dialogClassName="modal-190w"
        aria-labelledby="example-custom-modal-styling-title"
        size="xl"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header onHide={handleClose} closeButton className="modal_title">
          <Modal.Title id="example-custom-modal-styling-title">
            <div className="heading_new_loan  ps-2">New Loan Request</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`${loading ? "px-4" : "px-4 py-2"}`}>
          <div className={loading ? "onClickApplyLoaderStyl" : "d-none"}>
            <ThreeDots
              height="60"
              width="60"
              radius="9"
              color="#3d79f3"
              ariaLabel="three-dots-loading"
              wrapperStyle={{}}
              wrapperClassName=""
              visible={loading}
            />
          </div>
          <div className="row ">
            <div className="col-lg-8">
              <div className="row mb-2">
                <div className="col">
                  <p className="text_st">Business Name</p>
                  <div className="text_bolder">
                    {" "}
                    {props.data?.business_name}
                  </div>
                </div>
                <div className="col">
                  <p className="text_st">Loan Reference No.</p>
                  <span className="bolder_text">
                    {props.data?.loan_reference_number}
                  </span>
                </div>
                <div className="col">
                  <p className="text_st">Loan Type</p>
                  <span className="bolder_text">
                    {props.data?.loan_type_name === undefined ||
                      props.data?.loan_type_name === ""
                      ? "-"
                      : props.data?.loan_type_name}
                  </span>
                </div>
              </div>
              <div className="row mt-2 mb-2">
                <div className="col">
                  <p className="text_st">Requested Tenure </p>
                  <span className="bolder_text">
                    {props.data?.loan_tenure === undefined
                      ? "-"
                      : props.data?.loan_tenure}{" "}
                    {props.data?.loan_tenure === 1 ? " Month" : " Months"}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">Requested Loan Amount</p>
                  <span className="bolder_text">
                    {props.data?.loan_amount === undefined ||
                      props.data?.loan_amount === ""
                      ? "-"
                      : props.data?.loan_currency === LOAN_CURRENCY_TYPE_USD
                        ? "$"
                        : LOAN_CURRENCY_TYPE_BHD}{" "}
                    {Number(props.data?.loan_amount).toLocaleString()}
                  </span>
                </div>
                <div className="col-4">
                  <p className="text_st">
                    Approved Loan Amount<span style={{ color: "red" }}>*</span>
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <span className="bolder_text">
                      {props.data?.loan_currency === LOAN_CURRENCY_TYPE_USD ? "$" : LOAN_CURRENCY_TYPE_BHD}
                    </span>
                    <input
                      type="number"
                      className="APNL_option_flds rounded shadow-ben"
                      id="approved_amount"
                      name="approved_amount"
                      min="0"
                      placeholder="Enter amount"
                      autoComplete="off"
                      onChange={handleChangeInput}
                      onInput={(e) => (e.target.value = e.target.value.slice(0, 10))}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <p className="text_st">Loan Purpose</p>
                  <span className="bolder_text">
                    {props.data?.loan_purpose === undefined ||
                      props.data?.loan_purpose === ""
                      ? "-"
                      : props.data?.loan_purpose}{" "}
                  </span>
                </div>
              </div>
              <div className="row mb-1">
                <div className="col">
                  <p className="text_st"> Notes</p>
                  <div className="bolder_text newloan_notes">
                    {props.data?.notes === undefined || props.data?.notes === ""
                      ? "-"
                      : props.data?.notes}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4">
              {download.map((item) => {
                return (
                  <div key={item.doc_type} className="row  ps-4">
                    <div className="col-9">
                      <article className="text_bolde_doc ">
                        {item.document_type}{" "}
                      </article>
                    </div>
                    <div className="col d-flex justify-content-center">
                      <span className="" style={{
    pointerEvents: props.role_code === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.role_code === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                        {" "}
                        <a
                          style={{ display: "table-cell" }}
                          href={item.document_url}
                          target="_blank"
                        >
                          <img src="./images/eye.svg" alt="" />
                        </a>
                      </span>
                      <span
                      style={{display:props.role_code===AUDITOR_ROLE? 'none':''}}
                        className="Cpointer ps-3"
                        onClick={() =>
                          handleDownload(item.document_url, item.document_type)
                        }
                      >
                        <img src="./images/down.svg" alt="" />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <hr />
          <h3 className="benne_style">
            Bennefin agrees to give this loan with following details
          </h3>
          <div className="row bg-white">
            <div className="col">
              <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
                <li className="nav-item" role="presentation"></li>
              </ul>
            </div>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabIndex="0"
              >
                <div className="row gap-3">
                  <div className="col-lg">
                    <label htmlFor="tenure">
                      <p className="">
                        Loan Tenure<span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <select
                      id="tenure"
                      name="tenure"
                      className="form-select APNL_option_flds shadow-ben"
                      aria-label="form-select example"
                      onChange={handleChangeInput}
                    >
                      <option>Select</option>
                      {months.map((mnths, index) => {
                        return (
                          <option key={index}>
                            {mnths} {mnths == 1 ? " Month" : " Months"}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label htmlFor="bennefin">
                      <p>
                        For Borrower <span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <br />
                    <InputGroup className="mb-3 bootStrp_form_conrtl">
                      <Form.Control
                        type="text"
                        className="rounded  shadow-ben"
                        id="bennefin"
                        name="bennefin"
                        placeholder=""
                        required
                        role="presentation"
                        autoComplete="off"
                        onChange={handleChangeInput}
                        onInput={(e) => {
                          const input = e.target.value;
                          const decimalCount = (input.match(/\./g) || []).length;
                          if (decimalCount > 1 || input === '.') {
                            e.target.value = input.replace(/\./g, '');
                            return;
                          }
                          const [integerPart, decimalPart] = input.split('.');
                          if (integerPart && integerPart.length > 10) {
                            e.target.value = integerPart.slice(0, 10) + (decimalPart ? `.${decimalPart}` : '');
                          }
                        }}




                      />
                      <InputGroup.Text
                        className="percent_symbol"
                        id="basic-addon2"
                      >
                        %
                      </InputGroup.Text>
                    </InputGroup>
                  </div>

                  <div className="col-lg">
                    <label htmlFor="investor">
                      <p>
                        For Investor <span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <br />
                    <InputGroup className="mb-3 bootStrp_form_conrtl">
                      <Form.Control
                        className="  rounded  shadow-ben d-flex"
                        id="investor"
                        name="investor"
                        type="number"
                        placeholder=""
                        min={0}
                        aria-label=""
                        aria-describedby="basic-addon2"
                        onChange={handleChangeInput}
                        onInput={(e) => {
                          const input = e.target.value;
                          const decimalCount = (input.match(/\./g) || []).length;
                          if (decimalCount > 1 || input === '.') {
                            e.target.value = input.replace(/\./g, '');
                            return;
                          }
                          const [integerPart, decimalPart] = input.split('.');
                          if (integerPart && integerPart.length > 10) {
                            e.target.value = integerPart.slice(0, 10) + (decimalPart ? `.${decimalPart}` : '');
                          }
                        }}
                      />
                      <InputGroup.Text
                        className="percent_symbol"
                        id="basic-addon2"
                      >
                        %
                      </InputGroup.Text>
                    </InputGroup>
                  </div>

                  <div className="col-lg">
                    <label htmlFor="i_frequency">
                      <p>
                        {" "}
                        Interest Frequency{" "}
                        <span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <select
                      id="i_frequency"
                      className="form-select   shadow-ben APNL_option_flds"
                      aria-label="form-select example"
                      name="i_frequency"
                      autoComplete="off"
                      onChange={handleChangeInput}
                    >
                      <option>Select</option>
                      <option>Monthly</option>
                      <option>Quarterly </option>
                    </select>
                  </div>

                  <div className="col-lg-3" style={{ width: "200px" }}>
                    <label htmlFor="p_frequency">
                      <p>
                        {" "}
                        Principal Frequency{" "}
                        <span style={{ color: "red" }}>*</span>
                      </p>
                    </label>
                    <select
                      id="p_frequency"
                      className="form-select   shadow-ben APNL_option_flds"
                      aria-label="form-select example"
                      name="p_frequency"
                      autoComplete="off"
                      onChange={handleChangeInput}
                    >
                      <option>Select</option>
                      <option>Bullet Final Payment</option>
                      <option>Quarterly </option>
                      <option>Monthly</option>
                    </select>
                  </div>
                  <div className="col-lg">
                    <label htmlFor="currency ">
                      <p>Currency</p>
                    </label>
                    <select
                      id="currency"
                      name="currency"
                      className="form-select APNL_option_flds shadow-ben"
                      aria-label="form-select example"
                      onChange={handleChangeInput}
                    >
                      {currency_types.map((currency, index) => {
                        return props.data?.loan_currency === currency ? (
                          <option key={index} selected>
                            {currency === "USD" ? "USD" : "BHD"}
                          </option>
                        ) : (
                          <option key={index}>{currency}</option>
                        );
                      })}
                    </select>
                  </div>
                </div>

                <div className="row gap-3 justify-content-between me-3">
                  <div className="col-lg-3 d-flex">
                    <div className="row align-items-center">
                      <div>
                        <h3 className="mb-0">
                          Processing Fees{" "}
                          <span style={{ color: "red" }}>*</span>
                        </h3>
                      </div>

                      <div className="d-flex">
                        {ifrequency === "Quarterly"
                          ? processing_fee_options_isfrequency.map((item) => {
                            return (
                              <div className="col-lg-6 " key={item.id}>
                                <label
                                  onClick={radioButtonMethod}
                                  htmlFor={item.id}
                                >
                                  <input
                                    defaultChecked={true}
                                    id={item.id}
                                    type="radio"
                                    value={item.type}
                                    name="x"
                                  />
                                  <span className="ps-1 style_mb">
                                    {item.type}
                                  </span>
                                </label>
                              </div>
                            );
                          })
                          : processing_fee_options.map((item) => {
                            return (
                              <div className="col-lg-6 " key={item.id}>
                                <label
                                  onClick={radioButtonMethod}
                                  htmlFor={item.id}
                                >
                                  <input
                                    id={item.id}
                                    type="radio"
                                    value={item.type}
                                    name="x"
                                  />
                                  <span className="ps-1 style_mb">
                                    {item.type}
                                  </span>
                                </label>
                              </div>
                            );
                          })}
                      </div>
                      <div className="col-lg-6 ">
                        <label htmlFor="amount">
                          <p className="">
                            Amount <span style={{ color: "red" }}>*</span>
                          </p>
                        </label>
                        <input
                          type="number"
                          className=" APNL_option_flds rounded  shadow-ben"
                          id="amount"
                          name="amount"
                          min="0"
                          placeholder=""
                          onInput={(e) =>
                            (e.target.value = e.target.value.slice(0, 7))
                          }
                          autoComplete="off"
                          onChange={handleChangeInput}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg">
                    <div className="row ">
                      <div className="col-lg d-flex align-items-center my-2">
                        <div className="upload_report_btn_newloanRequest col-lg" style={{
    pointerEvents: props.role_code === AUDITOR_ROLE ? 'none' : 'auto',
    opacity: props.role_code === AUDITOR_ROLE ? 0.5 : 1,
  }}>
                          <label className="Cpointer ">
                            <input
                              type="file"
                              onChange={(e) => handleChangereupload(e)}
                            />
                            <span className="">
                              <img src="./images/upload.svg" alt="" /> Grading
                              document
                            </span>
                          </label>
                        </div>
                      </div>
                      <div className="col-lg-8 justify-content-center d-flex align-self-center">
                        <div className="mt-1 ">
                          <div className="upload_file_name ">
                            <div
                              className="container d-flex gap-5"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title={file}
                            >
                              <div>
                                {file != null
                                  ? file.length > 25
                                    ? file.slice(0, 25) + ".."
                                    : file
                                  : ""}
                              </div>
                              <div>
                                {file !== null && (
                                  <a
                                    style={{
                                      display: "table-cell",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i
                                      className="fa-solid fa-eye text-primary fa-eye-font mt-2"
                                      data-bs-toggle="tooltip"
                                      data-bs-placement="top"
                                      title="Click to view image"
                                      onClick={(e) =>
                                        handleChangeDownload(e, file)
                                      }
                                    />
                                  </a>
                                )}
                              </div>
                            </div>
                          </div>

                          {isUpload && (
                            <div className="loader">
                              <ThreeDots
                                height="30"
                                width="30"
                                radius="9"
                                color="#3D79F3"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                              />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="row">
                        <Form.Group className=" ">
                          <Form.Label className="business_text mb-0">
                            Reason
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder=""
                            id="admin_notes"
                            name="admin_notes"
                            onChange={handleChangeInput}
                            className="h-20"
                          // {props.data?.notes}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="about-document-upload mt-3">
                  <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                    <div>
                      <h3 className="bolder_text_p_fees mb-1">
                        About Business Document <span style={{ color: "red" }}>*</span>
                      </h3>
                      <p className="about-document-help mb-0">
                        Upload the DOCX or ODT file and preview the file.
                      </p>
                    </div>
                    <div className="d-flex flex-wrap gap-2">
                      <label className={`btn about-document-select-btn ${props.role_code === AUDITOR_ROLE ? "disabled" : ""}`}>
                        <input
                          type="file"
                          accept=".docx,.odt,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text"
                          onChange={handleAboutDocumentChange}
                          disabled={props.role_code === AUDITOR_ROLE || aboutPreviewLoading}
                        />
                        {aboutDocument ? "Replace document" : "Choose document"}
                      </label>
                      <button
                        type="button"
                        className="btn blue_btn"
                        disabled={!aboutDocument || aboutPreviewLoading || props.role_code === AUDITOR_ROLE}
                        onClick={handlePreviewAboutDocument}
                      >
                        {aboutPreviewLoading ? "Preparing preview..." : "Preview Document"}
                      </button>
                    </div>
                  </div>

                  {aboutDocument && (
                    <div className="about-document-file mt-3">
                      <div>
                        <strong>{aboutDocument.name}</strong>
                        <span>{(aboutDocument.size / 1024).toFixed(1)} KB</span>
                      </div>
                      <span className={aboutDocumentHash ? "about-document-ready" : "about-document-pending"}>
                        {aboutDocumentHash ? "Preview ready" : "Preview required"}
                      </span>
                    </div>
                  )}

                  <Form.Check
                    className="about-preview-confirmation mt-3"
                    type="checkbox"
                    id="about_preview_confirmed"
                    checked={aboutPreviewConfirmed}
                    disabled={!aboutDocumentHash || props.role_code === AUDITOR_ROLE}
                    onChange={(event) => setAboutPreviewConfirmed(event.target.checked)}
                    label="I have reviewed the About preview and confirm that it is correct."
                  />
                </div>

                <div>
                  <h3 className="bolder_text_p_fees mt-3">
                    Give this particular Investment Opportunity a Rating
                    <span style={{ color: "red" }}> *</span>
                  </h3>

                  <div className="row  mt-2">
                    {oppurtunity_ratings.map((rating, index) => {
                      return (
                        index % 2 === 0 && (
                          <div className="col-lg-6 " key={index}>
                            <div className="row">
                              <div className="col">
                                <input
                                  onClick={radioButtonMethodRating}
                                  className="style_input mt-3"
                                  type="radio"
                                  value={rating}
                                  name="A"
                                />
                              </div>
                              <div className="col">
                                {rating == "A" ? (
                                  <div className=" rating_txt_a">
                                    <div className="bb">{rating}</div>
                                  </div>
                                ) : (
                                  <div className=" rating_txt_c">
                                    <div className="bb">{rating}</div>
                                  </div>
                                )}
                              </div>
                              <div className="col-lg-10 text_st_ranking ps-3 pe-3">
                                {rating === "A"
                                  ? "An excellent opportunity with high potential for significant returns. These opportunities often involve low risk and have a strong likelihood of delivering substantial profits. "
                                  : rating === "C"
                                    ? "A fair opportunity with average potential for returns. These opportunities may involve some level of risk or uncertainty, and careful analysis is necessary to assess the potential risks and rewards. "
                                    : ""}
                              </div>
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                  <div className="row  mt-2">
                    {oppurtunity_ratings.map((rating, index) => {
                      return (
                        index % 2 !== 0 && (
                          <div className="col-6" key={index}>
                            <div className="row">
                              <div className="col-1 ">
                                <input
                                  onClick={radioButtonMethodRating}
                                  className="style_input mt-3"
                                  type="radio"
                                  value={rating}
                                  name="A"
                                />
                              </div>
                              <div className="col-1 ">
                                {rating === "B" ? (
                                  <div className=" rating_txt_b">
                                    <div className="bb">{rating}</div>
                                  </div>
                                ) : (
                                  <div className=" rating_txt_d">
                                    <div className="bb">{rating}</div>
                                  </div>
                                )}
                              </div>
                              <div className="col-10 text_st_ranking ps-3 pe-3 mb-2">
                                {rating === "B"
                                  ? "A good opportunity with above-average potential for returns. Although there may be some inherent risks associated with it, careful evaluation and management can lead to favorable outcomes."
                                  : rating === "D"
                                    ? "A poor opportunity with low potential for returns. It suggests a relatively high level of risk and uncertainty. These opportunities may have a higher chance of resulting in financial loss."
                                    : ""}
                              </div>
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between  pt-0 p-3 pb-1">
          <div>
            <label htmlFor="Assignee">
              <p className="ms-2">Assignee</p>
            </label>
            <select
              id="assignee"
              name="assignee"
              className="form-select shadow-ben"
              aria-label="form-select example"
              onChange={handleChangeInput}
            >
              {/* <option value="">Assignee</option> */}
              <option value={user}>{user}</option>
            </select>
          </div>
          <div className="">
            <button
              className="gray_btn btn mx-2 px-3 py-2"
              variant="secondary"
              onClick={handleClose}
            >
              Close
            </button>
            <button
              className="btn mx-2 py-2 px-3"
              style={{ backgroundColor: "#ED5151", color: "white" }}
              variant="secondary"
              onClick={handleShowReject}
              disabled={props.role_code===AUDITOR_ROLE}
            >
              Reject
            </button>
            <button
              className="btn blue_btn ms-2 py-2"
              variant="primary"
              disabled={activeTabBool || props.role_code===AUDITOR_ROLE || !aboutPreviewConfirmed || !aboutDocumentHash}
              onClick={handleSubmit(handleSavechanges)}
            >
              Push To Investor
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAboutPreview}
        onHide={() => setShowAboutPreview(false)}
        dialogClassName="about-preview-dialog"
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton className="modal_title">
          <Modal.Title>About Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {aboutPreviewWarnings.length > 0 && (
            <div className="about-preview-warning mb-3" role="alert">
              <strong>Please check these conversion notes:</strong>
              <ul className="mb-0 mt-2">
                {aboutPreviewWarnings.map((warning, index) => <li key={index}>{warning}</li>)}
              </ul>
            </div>
          )}
          <div
            className="about-business-content about-preview-content"
            dangerouslySetInnerHTML={{ __html: aboutPreviewHtml }}
          />
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn gray_btn" onClick={() => setShowAboutPreview(false)}>
            Close Preview
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show} onHide={handleCloseRejectClose}>
        <Modal.Header closeButton>
          <Modal.Title>Alert</Modal.Title>
        </Modal.Header>
        <div className=" alert_modal">Are you sure you want to reject?</div>
        <div className="p-2 d-flex justify-content-end gap-3">
          <button
            className="btn px-3"
            style={{ backgroundColor: "grey", color: "white" }}
            variant="primary"
            onClick={handleCloseRejectClose}
          >
            Cancel
          </button>
          <button
            className="btn px-4"
            style={{ backgroundColor: "#ED5151", color: "white" }}
            variant="danger"
            onClick={handleCloseReject}
          >
            Yes
          </button>
          
        </div>
      </Modal>
    </>
  );
};

export default AdminNewLoanRequest;
